export default {
  name: "SustainableSocialImpactNote",

  data() {
    return ({
      ssin_data: {
        kicker: "The Instrument",
        title: "The Sustainable Social Impact Note",
        description:
          "The SSIN transforms social good into a trackable asset class. It is a performance-linked note that tracks the impact of your capital.",
        note_kicker: "Sustainable Social Impact Note",
        note_value: "R1,000",
        note_series: "Series A",
        note_footer: "50 Notes = 1 Micro-Enterprise Unit",
      },

      ssin_features: [
        {
          key: "verified_impact",
          title: "Verified Social Impact",
          text:
            "Every SSIN is backed by real, measurable outcomes tracked through the VSI Platform in real-time.",
          icon: "✓",
          icon_box_class: "ssin-icon-soft",
        },
        {
          key: "financial_sustainability",
          title: "Financial Sustainability",
          text:
            "The circular model ensures your capital keeps working. Profit shares recycle to fund new enterprises perpetually.",
          icon: "▮▮▮",
          icon_box_class: "ssin-icon-cool",
        },
        {
          key: "tax_deductible",
          title: "100% Tax Deductible",
          text:
            "Administered via a registered PBO. Full Section 18A tax deductibility on every contribution.",
          icon: "▭",
          icon_box_class: "ssin-icon-warm",
        },
      ],
    });
  },
};
